import { render, staticRenderFns } from "./define-datafile.vue?vue&type=template&id=d0f46860&scoped=true"
import script from "./define-datafile.vue?vue&type=script&lang=js"
export * from "./define-datafile.vue?vue&type=script&lang=js"
import style0 from "./define-datafile.vue?vue&type=style&index=0&id=d0f46860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f46860",
  null
  
)

export default component.exports